import { ContiguousTimeslot } from "../timeslots.types";

export function getValidTimeslotsFromContiguousTimeslots(
  contiguousTimeslots: ContiguousTimeslot[],
  minDuration: number = 2
) {
  if (contiguousTimeslots.length === 0) return [];

  return contiguousTimeslots
    .filter((timeslot) => timeslot.duration >= minDuration)
    .map((timeslot) => timeslot.slotIds)
    .flat();
}

export default getValidTimeslotsFromContiguousTimeslots;
